import { Room } from '../types';

const convertRoomsForQuery = (rooms: Room[]) => {
  return rooms.reduce((acc: string[], room: Room) => {
    return [...acc, [room.adults, ...room.childrenAges].join(',')];
  }, []);
};

export default convertRoomsForQuery;
